import * as React from 'react';
import { Loading } from './Loading';

export const LoadingInline: React.FCC = () => <Loading className="co-m-loader--inline" />;
LoadingInline.displayName = 'LoadingInline';
